import UrlsConfig from "@/config/UrlsConfig";
import {Route} from "react-router-dom";
import {lazy} from "react";

import {
    referenceBookAppealsRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookAppealsRoutes";
import {
    referenceBookWorkingHoursRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookWorkingHoursRoutes";
import {
    referenceBookTestingRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookTestingRoutes";
import {
    referenceBookGEORoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookGEORoutes";
import {
    referenceBookDocumentSigningRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookDocumentSigningRoutes";
import {
    referenceBookLaboratoryClarificationsRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookLaboratoryClarificationsRoutes";
import {
    referenceBookLegalRequisitesRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookLegalRequisitesRoutes";
import {
    referenceBookProductCatalogsRoutes
} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/ReferenceBookListsRoutes/referenceBookProductCatalogsRoutes";
import {referenceBookBitrixRoutes} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/referenceBookBitrixRoutes";

const ReferenceBookFileExtensions = lazy(() => import("@/pages/ReferenceBooks/Lists/Files/FileExtensions/ReferenceBookFileExtensions"));
const ReferenceBookLkNotification = lazy(() => import("@/pages/ReferenceBooks/Lists/LkNotification/ReferenceBookLkNotification"));
const ReferenceBookHints = lazy(() => import("@/pages/ReferenceBooks/Lists/Hints/ReferenceBookHints"));
const ReferenceBookTableFields = lazy(() => import("@/pages/ReferenceBooks/Rules/TableFields/ReferenceBookTableFields"));
const ReferenceBookB24FieldMapping = lazy(() => import("@/pages/ReferenceBooks/Lists/B24FieldMapping/ReferenceBookB24FieldMapping"));
const ReferenceBookSyncGroupFields = lazy(() => import("@/pages/ReferenceBooks/Lists/SyncGroupFields/ReferenceBookSyncGroupFields"));
const ReferenceBookB24Stages = lazy(() => import("@/pages/ReferenceBooks/Lists/B24Stages/ReferenceBookB24Stages"));
const ReferenceBookB24StagesNew = lazy(() => import("@/pages/ReferenceBooks/Lists/B24StagesNew/ReferenceBookB24StagesNew"));
const ReferenceBookB24SmartProcesses = lazy(() => import("@/pages/ReferenceBooks/Lists/B24SmartProcesses/ReferenceBookB24SmartProcesses"));
const ReferenceBookB24Funnels = lazy(() => import("@/pages/ReferenceBooks/Lists/B24Funnels/ReferenceBookB24Funnels"));
const ReferenceBookB24Fields = lazy(() => import("@/pages/ReferenceBooks/Lists/B24Fields/ReferenceBookB24Fields"));
const ReferenceBookB24BusinessProcesses = lazy(() => import("@/pages/ReferenceBooks/Lists/B24BusinessProcesses/ReferenceBookB24BusinessProcesses"));
const ReferenceBookLisEntities = lazy(() => import("@/pages/ReferenceBooks/Lists/LisEntities/ReferenceBookLisEntities"));
const ReferenceBookEntities1C = lazy(() => import("@/pages/ReferenceBooks/Lists/Entities1C/ReferenceBookEntities1C"));
const ReferenceBookFunctionDescriptionTags = lazy(() => import("@/pages/ReferenceBooks/Lists/FunctionDescriptionTags/ReferenceBookFunctionDescriptionTags"));
const ReferenceBookFdLists = lazy(() => import("@/pages/ReferenceBooks/Lists/FdLists/ReferenceBookFdLists"));
const ReferenceBookServicePositions = lazy(() => import("@/pages/ReferenceBooks/Lists/ServicePositions/ReferenceBookServicePositions"));
const ReferenceBookB24CompanyPositions = lazy(() => import("@/pages/ReferenceBooks/Lists/B24CompanyPositions/ReferenceBookB24CompanyPositions"));
const ReferenceBookB24CompanyServices = lazy(() => import("@/pages/ReferenceBooks/Lists/B24CompanyServices/ReferenceBookB24CompanyServices"));
const ReferenceBookB24Tasks = lazy(() => import("@/pages/ReferenceBooks/Lists/B24Tasks/ReferenceBookB24Tasks"));
const ReferenceBookB24Entities = lazy(() => import("@/pages/ReferenceBooks/Lists/B24Entities/ReferenceBookB24Entities"));
const ReferenceBookFunctionDescription = lazy(() => import("@/pages/ReferenceBooks/Lists/FunctionDescription/ReferenceBookFunctionDescription"));
const ReferenceBookFirstTestTypes = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/FirstTestTypes/ReferenceBookFirstTestTypes"));
const ReferenceBooksLists = lazy(() => import("@/pages/ReferenceBooks/ReferenceBooksLists"));
const ReferenceBookBitrixFields = lazy(() => import("@/pages/ReferenceBooks/Lists/Other/ReferenceBookBitrixFields"));
const ReferenceBookPermissionSectionsDescriptions = lazy(() => import("@/pages/ReferenceBooks/Descriptions/ReferenceBookPermissionSectionsDescriptions"));
const ReferenceBookPermissionSectionActionsDescriptions = lazy(() => import("@/pages/ReferenceBooks/Descriptions/ReferenceBookPermissionSectionActionsDescriptions"));
const ReferenceBookPartnerCalculatedGroups = lazy(() => import("@/pages/ReferenceBooks/Lists/Partners/ReferenceBookPartnerCalculatedGroups"));
const ReferenceBookPartnerSearchColumnCategories = lazy(() => import("@/pages/ReferenceBooks/Lists/Partners/ReferenceBookPartnerSearchColumnCategories"));

const urlsConfig = new UrlsConfig();

export function referenceBookListsRoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBooksLists.to} element={<ReferenceBooksLists/>}/>

          {referenceBookAppealsRoutes()}
          {referenceBookWorkingHoursRoutes()}
          {referenceBookTestingRoutes()}
          <Route path={urlsConfig.referenceBookFirstTestTypes.to} element={<ReferenceBookFirstTestTypes/>}/>
          {referenceBookGEORoutes()}
          {/* Document signing and storage for our legal entities and partners */}
          {referenceBookDocumentSigningRoutes()}

          {/* FILE EXTENSIONS */}
          <Route path={urlsConfig.referenceBookFileExtensions.to} element={<ReferenceBookFileExtensions/>}/>
          <Route path={urlsConfig.referenceBookLkNotification.to} element={<ReferenceBookLkNotification/>}/>
          <Route path={urlsConfig.referenceBookHints.to} element={<ReferenceBookHints/>}/>
          <Route path={urlsConfig.referenceBookTableFields.to} element={<ReferenceBookTableFields/>}/>
          <Route path={urlsConfig.referenceBookB24FieldMapping.to} element={<ReferenceBookB24FieldMapping/>}/>
          <Route path={urlsConfig.referenceBookSyncGroupFields.to} element={<ReferenceBookSyncGroupFields/>}/>
          <Route path={urlsConfig.referenceBookB24Stages.to} element={<ReferenceBookB24Stages/>}/>
          <Route path={urlsConfig.referenceBookB24StagesNew.to} element={<ReferenceBookB24StagesNew/>}/>
          <Route path={urlsConfig.referenceBookB24SmartProcesses.to} element={<ReferenceBookB24SmartProcesses/>}/>
          <Route path={urlsConfig.referenceBookB24Funnels.to} element={<ReferenceBookB24Funnels/>}/>
          <Route path={urlsConfig.referenceBookB24Fields.to} element={<ReferenceBookB24Fields/>}/>
          <Route path={urlsConfig.referenceBookB24BusinessProcesses.to} element={<ReferenceBookB24BusinessProcesses/>}/>
          <Route path={urlsConfig.referenceBookLisEntities.to} element={<ReferenceBookLisEntities/>}/>
          <Route path={urlsConfig.referenceBookEntities1C.to} element={<ReferenceBookEntities1C/>}/>
          <Route path={urlsConfig.referenceBookFunctionDescriptionTags.to} element={<ReferenceBookFunctionDescriptionTags/>}/>
          <Route path={urlsConfig.referenceBookFdLists.to} element={<ReferenceBookFdLists/>}/>
          <Route path={urlsConfig.referenceBookServicePositions.to} element={<ReferenceBookServicePositions/>}/>
          <Route path={urlsConfig.referenceBookB24CompanyPositions.to} element={<ReferenceBookB24CompanyPositions/>}/>
          <Route path={urlsConfig.referenceBookB24CompanyServices.to} element={<ReferenceBookB24CompanyServices/>}/>
          <Route path={urlsConfig.referenceBookB24Tasks.to} element={<ReferenceBookB24Tasks/>}/>
          <Route path={urlsConfig.referenceBookB24Entities.to} element={<ReferenceBookB24Entities/>}/>
          <Route path={urlsConfig.referenceBookBitrixFields.to} element={<ReferenceBookBitrixFields/>}/>
          <Route path={urlsConfig.referenceBookFunctionDescription.to} element={<ReferenceBookFunctionDescription/>}/>

          {/* Partners */}
          <Route path={urlsConfig.referenceBookPartnerCalculatedGroups.to} element={<ReferenceBookPartnerCalculatedGroups/>}/>
          <Route path={urlsConfig.referenceBookPartnerSearchColumnCategories.to} element={<ReferenceBookPartnerSearchColumnCategories/>}/>

          {/* DESCRIPTIONS */}
          <Route path={urlsConfig.referenceBooksListsSectionsDescriptions.to} element={<ReferenceBookPermissionSectionsDescriptions/>}/>
          <Route path={urlsConfig.referenceBooksListsActionsDescriptions.to} element={<ReferenceBookPermissionSectionActionsDescriptions/>}/>

          {referenceBookLaboratoryClarificationsRoutes()}
          {referenceBookLegalRequisitesRoutes()}
          {referenceBookProductCatalogsRoutes()}
          {referenceBookBitrixRoutes()}
      </>
    );
}
